export default __webpack_public_path__ + "static/media/Nitrox2016.19dee284.jpg";